export const getBreadCrumb = (area, pref, cityName) => {
  if (!area) {
    return [
      { text: '風レーダー' }
    ]
  } else if (!pref) {
    return [
      { text: '風レーダー', link: '../' },
      { text: getAreaPrefectureName(area) }
    ]
  } else if (cityName) {
    return [
      { text: '風レーダー', link: '../../../' },
      { text: getAreaPrefectureName(area), link: '../../' },
      { text: getAreaPrefectureName(pref), link: '../' },
      { text: cityName }
    ]
  } else {
    if (area === 'okinawa') {
      return [
        { text: '風レーダー', link: '../../' },
        { text: getAreaPrefectureName(area), link: '../' },
        { text: pref }
      ]
    }
    return [
      { text: '風レーダー', link: '../../' },
      { text: getAreaPrefectureName(area), link: '../' },
      { text: getAreaPrefectureName(pref) }
    ]
  }
}
